import { render, staticRenderFns } from "./wishlist.vue?vue&type=template&id=77c61bee&scoped=true"
import script from "./wishlist.vue?vue&type=script&lang=js"
export * from "./wishlist.vue?vue&type=script&lang=js"
import style0 from "./wishlist.vue?vue&type=style&index=0&id=77c61bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c61bee",
  null
  
)

export default component.exports